export const UserFormConfig = {
  institutionUserId: "",
  institutionId: "",
  userId: "",
  user: {
    name: "",
    dob: "",
    gender: "",
    parentName: "",
    phoneNumber: "",
    email: "",
    emergencyContactNo: "",
    destination: "",
    rfid: false,
    rfidNo: "",
    uhf: false,
    uhfId: "",
    startDate: "",
    endDate: "",
    userRole: "",
    userType: "",
    admissionNo: "",
    className: "",
    vehicles: [],
    phone: "",
    sectionName: "",
    secondaryNumber: "",
    profileImage: "",
    pickup: "",
    drop: "",
    empStopName: "",
    empCategoryName: "",
    empCategory: "",
    hasBp: false,
    isTransport: "1"
  },
  student: {
    userId: "",
    studentName: "",
    dob: "",
    studentId: "",
    className: "",
    sectionName: "",
    admissionNo: "",
    pickup: "",
    drop: ""
  },
  employee: {
    employeeId: "",
    dob: "",
    empDepartment: "",
    destination: "",
    employeeType: "",
    agency: "",
    category: "",
    shift: "",
    pickup: "",
    drop: "",
    empStopName: "",
    empCategoryName: "",
    empCategory: ""
  }
};
